/** Loading skeletons -- shimmer respects prefers-reduced-motion via CSS. */

export function SkeletonLines({ lines = 3 }: { lines?: number }) {
  const widths = ["skel-w80", "skel-w60", "skel-w40"];
  return (
    <div className="skeleton" role="status" aria-label="Lädt">
      {Array.from({ length: lines }, (_, i) => (
        <div key={i} className={`skel-line ${widths[i % widths.length]}`} />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 4 }: { rows?: number }) {
  return (
    <div className="skeleton" role="status" aria-label="Lädt">
      <div className="skel-line skel-w40" />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skel-line" />
      ))}
    </div>
  );
}

export function SkeletonKpis({ count = 4 }: { count?: number }) {
  return (
    <div className="kpi-grid" role="status" aria-label="Lädt">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skel-block" />
      ))}
    </div>
  );
}
